module.exports = __webpack_public_path__ + "static/img/app-icon.9f75af4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/app-icon.png
// module id = wGiD
// module chunks = 74